<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="340">
      <v-card class="card-container" light>
        <v-card-title class="title-style">{{ title }}</v-card-title>
        <v-card-text class="text-style">{{ text }}</v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Díalogo'
    },
    title: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      dialog: false
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
    }
  }
}
</script>

<style scoped>

.title-style {
  font-size: large;
  text-align: center;
}

.text-style{
  font-size: medium;
  text-align: center;
}

</style>
